<!--  -->
<template>
  <div class="study">
    <div class="left">
      <div @click="openChat">
        <img src="@/assets/img/productDetail/icon_custom.png" alt />
        <span>咨询</span>
      </div>
    </div>
    <button class="to-study" @click="goQiHangMini">前往 [启航考研] 购买</button>
  </div>
</template>
<script>
import { setTokenFromCookie, gioEnterCart } from '@/utils/tools';
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
import { setBaseUrl } from '@/utils/tools'
import { miniSchemeUrl } from '@/utils/common';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() { },

  methods: {
    async goQiHangMini() {
      const path = '/subPackages/detailWebView/index';
      const url = window.location.href
      const params = url.replace(/([&?])miniSource=[^&]*&?/g, '$1');
      wx.miniProgram.navigateTo({
        url: `/subPackages/goQiHang/index?path=${encodeURIComponent(path)}&params=${encodeURIComponent(params)}`,
      });
    },
    openChat() {
      wx.miniProgram.navigateTo({
        url: `/subPackages/mantisChat/mantisChat?chatPageUrl=${encodeURIComponent(`https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=${'6a153e1910c0770001b8a1ba'}`)}&probeId=${'6a153e1910c0770001b8a1ba'}`,
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.study {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 22px 40px;
  background: #fff;

  .left {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;

    >div {
      padding-right: 30px;

      img {
        display: block;
        width: 48px;
        height: 48px;
      }

      span {
        display: block;
        color: #333;
        font-weight: 400;
        font-size: 20px;
      }
    }
  }

  button.to-study {
    width: 598px;
    height: 82px;
    color: #fff;
    font-weight: 500;
    font-size: 32px;
    line-height: 82px;
    background: #ff6c02;
    border-radius: 45px;
  }

  button.to-study.mini {
    width: 400px;
  }
}
</style>
